import _toConsumableArray from "D:/xampp/htdocs/SNS_Thai/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import $ from 'jquery';
import md5 from 'md5';
var jsonp = require('jsonp');
import { threadList, banner, follow, unFollow, thumbs, collect } from '@/api/mg';
var threadListParams = {
  perPage: 10,
  page: 1,
  'filter[essence]': 0,
  'filter[attention]': 0,
  'filter[sort]': 3,
  sequence: 0,
  'filter[categoryids][0]': 1,
  'filter[sticky]': 2
};
export default {
  data: function data() {
    return {
      topData: [],
      userId: '',
      totalPage: 0,
      clubData: [],
      typeArr: [{
        txt: 'Hot',
        selected: false
      }, {
        txt: 'Latest',
        selected: true
      }, {
        txt: 'Follow',
        selected: false
      }],
      type: 'Latest',
      isShowSelectPop: false,
      isShowWrap: false,
      loading: false,
      finished: false,
      isLoading: false,
      banner: [
        // { src: require('../../../assets/images/Banner1.png') },
        // { src: require('../../../assets/images/Banner2.png') }
      ],
      infos: [{
        isFollow: true
      }, {
        isFollow: false
      }, {
        isFollow: true
      }, {
        isFollow: false
      }]
    };
  },
  created: function created() {
    this.getThreadList({
      perPage: 10,
      page: 1,
      'filter[categoryids][0]': 1,
      'filter[sticky]': 1
    });
    this.userId = localStorage.getItem('userId');
    threadListParams.page = 1;
    threadListParams['filter[sort]'] = 1;
    this.getThreadList(threadListParams);
    this.getBanner({
      page: 1,
      perPage: 6
    });
  },
  mounted: function mounted() {
    console.log('首屏加载时间为' + (new Date().getTime() - performance.timing.navigationStart) + 'ms');
    var that = this;
    this.$nextTick(function () {
      $('.wrap').on('click', function () {
        that.isShowSelectPop = false;
        that.isShowWrap = false;
      });
    });
  },
  methods: {
    getOrigin: function getOrigin(item) {
      item.isTranslate = false;
    },
    translate: function translate(item) {
      var _this = this;
      if (item.content.dst) {
        item.isTranslate = true;
        return;
      }
      var appid = '20211116001000645'; // 百度翻译API的appid
      var key = 'RExx85Y9o4DqUHOrcaqV'; // 百度翻译API的key
      var salt = new Date().getTime();
      var query = item.content.text;
      var from = 'th';
      var to = 'en';
      var str1 = appid + query + salt + key;
      var sign = md5(str1);
      var url = "http://api.fanyi.baidu.com/api/trans/vip/translate?q=".concat(query, "&appid=").concat(appid, "&salt=").concat(salt, "&from=").concat(from, "&to=").concat(to, "&sign=").concat(sign);
      jsonp(url, null, function (err, data) {
        if (err) {
          _this.$toast(err.error_msg);
        } else {
          item.isTranslate = true;
          item.content.dst = data.trans_result[0].dst;
        }
      });
    },
    toCollect: function toCollect(item) {
      var _this2 = this;
      var params = {
        id: item.threadId,
        isFavorite: !item.isFavorite
      };
      collect(params).then(function (res) {
        if (res.Code === 0) {
          if (item.isFavorite) {
            item.likeReward.favoriteCount -= 1;
          } else {
            item.likeReward.favoriteCount += 1;
          }
          item.isFavorite = !item.isFavorite;
        } else {
          _this2.$toast(res.Message);
        }
      });
    },
    thumbsUp: function thumbsUp(item) {
      var _this3 = this;
      var params = {
        data: {
          attributes: {
            isLiked: !item.isLike
          }
        },
        pid: item.postId,
        id: item.threadId
      };
      params.token = JSON.parse(localStorage.getItem('appParams')).token;
      thumbs(params).then(function (res) {
        if (res.Code === 0) {
          if (item.isLike) {
            item.likeReward.likePayCount -= 1;
          } else {
            item.likeReward.likePayCount += 1;
          }
          item.isLike = !item.isLike;
        } else {
          _this3.$toast(res.Message);
        }
      });
    },
    toMe: function toMe(pid) {
      this.$router.push({
        path: '/others',
        query: {
          pid: pid
        }
      });
    },
    toFollow: function toFollow(userId, item, str) {
      var _this4 = this;
      var params = {
        toUserId: userId
      };
      follow(params).then(function (res) {
        if (res.Code === 0) {
          if (str) {
            _this4.topData.forEach(function (itm) {
              if (itm.user.userId === item.user.userId) {
                itm.user.follow_status_false = '0';
              }
            });
          } else {
            console.log(item.user.userId);
            _this4.clubData.forEach(function (itm) {
              console.log(itm.user.userId);
              if (itm.user.userId === item.user.userId) {
                itm.user.follow_status_false = '0';
              }
            });
          }
        } else {
          _this4.$toast(res.Message);
        }
      });
    },
    toUnfollow: function toUnfollow(userId, item, str) {
      var _this5 = this;
      var params = {
        type: 1,
        id: userId
      };
      console.log(unFollow, 'params');
      unFollow(params).then(function (res) {
        if (res.Code === 0) {
          if (str) {
            _this5.topData.forEach(function (itm) {
              if (itm.user.userId === item.user.userId) {
                itm.user.follow_status_false = '2';
              }
            });
          } else {
            _this5.clubData.forEach(function (itm) {
              if (itm.user.userId === item.user.userId) {
                itm.user.follow_status_false = '2';
              }
            });
          }
        } else {
          _this5.$toast(res.Message);
        }
      });
    },
    toUrl: function toUrl(url) {
      // this.$router.push({ path: url })
    },
    getBanner: function getBanner(params) {
      var _this6 = this;
      banner(params).then(function (res) {
        if (res.Code === 0) {
          _this6.banner = res.Data.pageData;
        } else {
          _this6.$toast(res.Message);
        }
      });
    },
    getThreadList: function getThreadList(params) {
      var _this7 = this;
      threadList(params).then(function (res) {
        if (res.Code === 0) {
          if (params['filter[sticky]'] === 1) {
            _this7.topData = res.Data.pageData;
            _this7.topData.forEach(function (item) {
              item.user.follow_status_false = item.user.follow_status;
            });
            return;
          }
          _this7.totalPage = res.Data.totalPage;
          res.Data.pageData.forEach(function (item) {
            item.isTranslate = false;
            item.user.follow_status_false = item.user.follow_status;
          });
          _this7.clubData = [].concat(_toConsumableArray(_this7.clubData), _toConsumableArray(res.Data.pageData));
          _this7.loading = false;
          _this7.isLoading = false;
        } else {
          _this7.$toast(res.Message);
        }
      });
    },
    toSelect: function toSelect(item) {
      if (item.selected) {
        return;
      }
      this.typeArr.forEach(function (itm) {
        itm.selected = false;
      });
      item.selected = true;
      this.isShowWrap = false;
      this.isShowSelectPop = false;
      this.type = item.txt;
      this.clubData = [];
      var obj = {
        'Hot': 3,
        'Latest': 1,
        'Follow': 2
      };
      threadListParams['filter[sort]'] = obj[item.txt];
      threadListParams.page = 1;
      this.finished = false;
      this.getThreadList(threadListParams);
    },
    showSelectPop: function showSelectPop() {
      this.isShowWrap = true;
      this.isShowSelectPop = true;
    },
    onLoad: function onLoad() {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      threadListParams.page++;
      if (threadListParams.page <= this.totalPage) {
        this.getThreadList(threadListParams);
      } else {
        this.finished = true;
      }
      // setTimeout(() => {
      //   for (let i = 0; i < 10; i++) {
      //     this.infos.push(this.infos.length + 1)
      //   }

      //   // 加载状态结束
      //   this.loading = false

      //   // 数据全部加载完成
      //   if (this.infos.length >= 20) {
      //     this.finished = true
      //   }
      // }, 1000)
    },
    answerQuestion: function answerQuestion() {
      this.$router.push({
        path: '/social/questionList'
      });
    },
    toManual: function toManual() {
      this.$router.push({
        path: '/social/manual'
      });
    },
    toTestDrive: function toTestDrive() {
      // this.$router.push({ path: '/social/testDrive' })
    },
    toTopic: function toTopic(topicId) {
      this.$router.push({
        path: '/social/topic',
        query: {
          topicId: topicId
        }
      });
    },
    onRefresh: function onRefresh() {
      this.finished = false;
      this.clubData = [];
      this.topData = [];
      this.getThreadList({
        perPage: 10,
        page: 1,
        'filter[categoryids][0]': 1,
        'filter[sticky]': 1
      });
      threadListParams.page = 1;
      this.getThreadList(threadListParams);
      // setTimeout(() => {
      //   this.$toast('刷新成功')
      //   this.isLoading = false
      // }, 1000)
    },
    toDetail: function toDetail(threadId) {
      this.$router.push({
        path: '/social/detail',
        query: {
          from: 'club',
          threadId: threadId
        }
      });
    }
  }
};